import { REQUEST_TIME_SLOTS, REQUEST_TIME_SLOTS_ERROR, REQUEST_TIME_SLOTS_SUCCESS, UPDATE_SCHEDULE_SLOT, UPDATE_SCHEDULE_SLOT_ERROR, UPDATE_SCHEDULE_SLOT_SUCCESS } from './Constants';

export const timeSlotRequest = (payload) => ({
    type: REQUEST_TIME_SLOTS,
    payload : payload
});

export const timeSlotRequestSuccess = (data) => ({
    type: REQUEST_TIME_SLOTS_SUCCESS,
    data : data
});

export const timeSlotRequestError = () => ({
    type: REQUEST_TIME_SLOTS_ERROR
});

export const updateScheduleSlotRequest = (payload) => ({
    type: UPDATE_SCHEDULE_SLOT,
    payload : payload
});

export const updateScheduleSlotRequestSuccess = (data) => ({
    type: UPDATE_SCHEDULE_SLOT_SUCCESS,
    data : data
});

export const updateScheduleSlotRequestError = () => ({
    type: UPDATE_SCHEDULE_SLOT_ERROR
});